import PropTypes from 'prop-types';

// React modal doesn't seem to support proptypes
var propTypes = {
    hasBackgroundBlur: PropTypes.bool,
};
var defaultProps = {
    hasBackgroundBlur: false,
};

export { defaultProps, propTypes };
